




/// =================
/// Правки работы

import { ID } from '../core/id';


export const HOURS_DEDLINE_CORRECT = 24; // 24 часа
/// =================
export enum WorkCorrectCause {
    EDIT_TEXT = "edit_text",
    EDIT_TEXT_AI = "edit_text_ai",
    NO_FOTO = "no_foto",
    BAD_NAME = "bad_name",
    GENDER = "gender",
}

export interface WorkCorrect {
    id: ID;
    work_id: ID;
    cause: WorkCorrectCause;
    client_comment: string;
    executor_comment: string;
    is_ready: boolean;
    date_modified: number;
    date_published: number;
}
export const WORK_CORRECT_CAUSE_NAMES: Record<WorkCorrectCause, string> = {
    [WorkCorrectCause.EDIT_TEXT]: "Исправить текст",
    [WorkCorrectCause.EDIT_TEXT_AI]: "Исправить текст (AI)",
    [WorkCorrectCause.NO_FOTO]: "Добавить фото",
    [WorkCorrectCause.BAD_NAME]: "Исправить имя",
    [WorkCorrectCause.GENDER]: "Пол имени и текста разный",
};
